import React, { Fragment, PureComponent } from "react";
import { Checkbox } from "antd";
import ButtonStep from "./../../ButtonStep";
import _ from "lodash";
import { assign, zipObject, xor } from "lodash/fp";

class SurveyStepEmplacement extends PureComponent {
  state = {
    selectedLocations: [],
    locations: []
  };

  componentDidMount() {
    let surveyLocations = this.props.surveyProgress.locations;
    if (surveyLocations.length !== 0) {
      this.setState({
        selectedLocations: surveyLocations
      });
      this.props.handleDisabled(false);
    }
    this.setState({
      locations: this.props.locatonList
    });
    //this.props.getKpiList();
  }

  onChange = (item = {}) => {
    let surveyProgress = this.props.surveyProgress;

    const target = item.target;
    if (!target) return;
    surveyProgress.locationTypes = [];
    surveyProgress.locations = surveyProgress.locations || [];
    const checked = target.checked;
    const value = target.value || {};

    if (checked) {
      surveyProgress.locations.unshift(value);
      surveyProgress.locations = _.uniqBy(surveyProgress.locations, "locationTypeId");

      //order locations
      const orderedLocations = [];
      const locations = this.props.locatonList || [];
      for (let i = 0; i < locations.length; i++) {
        const location = locations[i];
        const locationFromSurvey = _.find(surveyProgress.locations, {
          locationTypeId: location.locationTypeId
        });
        if (locationFromSurvey) {
          orderedLocations.push(locationFromSurvey);
        }
      }
      surveyProgress.locations = orderedLocations;
    } else {
      _.remove(surveyProgress.locations, {
        locationTypeId: value.locationTypeId
      });
    }

    this.props.resetSimulation();
    this.props.addStepSurvey(_.cloneDeep(surveyProgress));
    if (surveyProgress.locations.length < 1) {
      this.props.handleDisabled(true);
    }
    if (surveyProgress.locations.length > 0) {
      this.props.handleDisabled(false);
    }
    return;
  };

  next = current => {
    this.props.handleDisabled(true);
    this.props.next(current);
  };

  render() {
    const locations = this.props.locatonList || [];
    const selectedLocations = this.props.surveyProgress.locations || [];
    const { current, steps, prev, sucess, disabled } = this.props;
    return (
      <Fragment>
        <ButtonStep
          current={current}
          steps={steps}
          prev={() => prev(current)}
          next={() => this.next(current)}
          sucess={() => sucess(current)}
          disabled={disabled}
        />
        <div className="p-txt-italic">- Sélectionner les emplacements :</div>
        <div className="p-mrg-bot-l p-al-left">
          {locations.map((location, index) => {
            let checked =
              _.findIndex(selectedLocations, {
                locationTypeId: location.locationTypeId
              }) !== -1;
            return (
              <div className={`p-survey-longblock p-mrg-right-s p-mrg-top ${checked ? "selected" : null}`} key={index}>
                <Checkbox value={location} onChange={item => this.onChange(item)} checked={checked}>
                  <span className={`${checked ? "p-txt-bold p-clr-blck" : ""}`}>{location.label}</span>
                </Checkbox>
              </div>
            );
          })}
        </div>
      </Fragment>
    );
  }
}

export default SurveyStepEmplacement;



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepEmplacement/SurveyStepEmplacement.js